import * as z from "zod"
import { AircraftType } from "@prisma/client"

export const AircraftConstraintModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  provider_id: z.string().nullish(),
  aircraft_id: z.string(),
  aircraft_type: z.nativeEnum(AircraftType),
  max_length: z.number().nullish(),
  max_width: z.number().nullish(),
  max_height: z.number().nullish(),
  max_weight: z.number().nullish(),
  smallest_max_cm: z.number().nullish(),
  biggest_max_cm: z.number().nullish(),
})
